import { render, staticRenderFns } from "./OsCardText.vue?vue&type=template&id=26094f77&scoped=true"
import script from "./OsCardText.vue?vue&type=script&lang=ts"
export * from "./OsCardText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26094f77",
  null
  
)

export default component.exports